import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {ApiService, EnvironmentModel, ObservableData} from '@cas-hub/acabim-common-client';
import {AssetTypeResponse, AssetTypeRequest, AssetTypesResponse} from '../_models/asset-type.model';

@Injectable({
    providedIn: 'root'
})
export class AssetTypeService extends ApiService {

    constructor(protected client: HttpClient, protected environment: EnvironmentModel) {
        super(client, environment);
    }

    protected controller = 'asset-type';

    /**
     * Add a new or update an existing asset type
     * @returns An asset type object
     */
    public upsertAssetType(name: string, description: string, id?: string) {
        const body: AssetTypeRequest = {
            name,
            description
        };
        const endpoint = id ? id : '';
        return this.client.post(this.url(endpoint), body, {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => item as AssetTypeResponse));
    }

    /**
     * Retrieve a single asset type
     * @returns Asset type details
     */
    public getAssetType(id: number): Observable<AssetTypeResponse> {
        return this.client.get(this.url(id.toString()), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => {
            console.dir(item);
            return item as AssetTypeResponse;
        }));
    }

    /**
     * Delete a asset types
     * @returns Accepted
     */
    public deleteAssetType(id: number): Observable<boolean> {
        return this.client.delete(this.url(id.toString()), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(map(item => {
            console.dir(item);
            return true;
        }));
    }

    /**
     * Retrieve all asset types
     * @returns An array of asset types
     */
    public getAssetTypes(): Observable<ObservableData<AssetTypeResponse>>  {
        return this.client.get(this.url(''), {
            headers: this.defaultHeaders,
            responseType: 'json'
        }).pipe(tap(data => console.log(data)), map(data => ({
            totalRecords: (data as AssetTypesResponse).count,
            data: (data as AssetTypesResponse).data
        })));
    }


}
